import React, {useEffect} from "react";
import {toast} from "react-toastify";
import {Bars} from "react-loader-spinner";
import {useGetSensorAnalysis} from "../hooks/useGetSensorAnalysis";
import {useDownloadAnalysisCSV} from "../hooks/useDownloadAnalysisCSV";
import DownloadAnalysisCSV from "./downloadAnalysisCSV";

const DownloadSensorAnalysis = (props) => {
  const {name, id, count} = props;
  const {analysis, isLoading} = useGetSensorAnalysis(id);
  const {handleDownload, isDownloading} = useDownloadAnalysisCSV(analysis, name);

  const onDownload = () => {
    if (isLoading) {
      toast.info("Only loaded data will be downloaded", {
        toastId: "dataNotLoaded",
      });
    } else {
      handleDownload();
    }
  };

  useEffect(() => {
    if (count > 0) {
      onDownload();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count]);

  return (
    <div style={{display: "flex", alignItems: "center", padding: "10px 0px"}}>
      <div style={{marginRight: "20px"}}>{name}</div>
      {isLoading ? (
        <Bars height="20" width="30" color="#11cdef" ariaLabel="bars-loading" />
      ) : (
        <DownloadAnalysisCSV isDownloading={isDownloading} onDownload={onDownload} />
      )}
    </div>
  );
};

export default DownloadSensorAnalysis;
